import * as React from 'react';


/** Rating Review component*/
const RatingReview = (props : { rating: number, setRating: any }) => {

    return (
        <div>
            {[1, 2, 3, 4, 5].map((star) => {
                return (
                    <span
                        className='start'
                        style={{
                            cursor: 'pointer',
                            color: props.rating >= star ? 'gold' : 'gray',
                            fontSize: `35px`,
                        }}
                        onClick={() => {
                            props.setRating(star)
                        }}
                    >
                        {' '}
                        ★{' '}
                    </span>
                )
            })}
        </div>
    );
}

export default RatingReview;
